module.exports = __webpack_public_path__ + "img/symbol_5.cf5151e8.png";